import { render, staticRenderFns } from "./ProductMatchHome.vue?vue&type=template&id=fda0de12&"
import script from "./ProductMatchHome.vue?vue&type=script&lang=js&"
export * from "./ProductMatchHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports